export default __webpack_public_path__ + "static/banner3-c0e60c64b2cbbfaa4f57ce044f7686c8.png";